import React from "react";
import {Controller, useForm, useWatch} from "react-hook-form";
import moment from "moment";
import {useLocation, useNavigate} from "react-router-dom";
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Container, Drawer, FormControlLabel, IconButton, InputAdornment, List, ListItem, ListItemText, MenuItem, Modal, Switch, TextField, Typography} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HistoryIcon from "@mui/icons-material/History";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import SaveIcon from "@mui/icons-material/Save";
import ScheduleIcon from "@mui/icons-material/Schedule";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import UTurnLeftIcon from "@mui/icons-material/UTurnLeft";
import AddService from "./partial/AddService";
import PastVital from "./partial/PastVital";
import PastRemarks from "./partial/PastRemarks";
import {getInstructions, setInstructionsUpdate, setLastData, setVisitCancellation, setVisitStart, setVisitUpdate} from "../api/client";

const InstructionForm = (props) => {
  const control = props.control;
  const st004310List = useWatch({control, name: "st004310List"});
  const charInputList = useWatch({control, name: "charInputList"});
  return (
    <>
    <Container
      sx = {{padding: "0px!important", display: "flex"}}
    >
      <FormControlLabel
        control = {
          <Checkbox
            icon = {<RadioButtonUncheckedIcon />}
            checkedIcon = {
              <TaskAltIcon
                color = {Boolean(parseInt(props.getValues("adminCheckFg"))) || !Boolean(parseInt(props.getValues("status"))) || parseInt(props.getValues("status")) > 2 ? "disabled" : "success"}
              />
            }
            color = "default"
            checked = {Boolean(st004310List.find(st004310 => st004310[0] === props.st[0]))}
            name = "st004310List"
            onChange = {(e) => props.onClick(e, props.st)}
          />
        }
        disabled = {Boolean(parseInt(props.getValues("adminCheckFg"))) || !Boolean(parseInt(props.getValues("status"))) || parseInt(props.getValues("status")) > 2}
        label = {props.st[1]}
        // label = {(props.getValues("serviceList").map(svsLst => svsLst[1].filter(svs => svs[0] === parseInt(props.st))).filter(svsLst => Boolean(svsLst.length))[0] || [[]])[0][1]}
        sx = {{m: 0, pl: 1}}
      />
    </Container>
    {Boolean(st004310List.find(st004310 => st004310[0] === props.st[0])) && Boolean(charInputList.find(char => char[0] === props.st[0])) &&
    <Container
      sx = {{padding: "0px!important", display: "flex"}}
    >
      <TextField
        value = {props.getValues("charInputList").find(char => char[0] === props.st[0])[1] || ""}
        disabled = {Boolean(parseInt(props.getValues("adminCheckFg"))) || !Boolean(parseInt(props.getValues("status"))) || parseInt(props.getValues("status")) > 2}
        fullWidth
        inputProps = {{maxLength: 50}}
        maxRows = {5}
        minRows = {1}
        multiline
        onChange = {(e) => props.onChange(e.target.value)}
        placeholder = {props.st[1]}
        // placeholder = {(props.getValues("serviceList").map(svsLst => svsLst[1].filter(svs => svs[0] === parseInt(props.st))).filter(svsLst => Boolean(svsLst.length))[0] || [[]])[0][1]}
        size = "small"
        sx = {{ml: 5, mr: 2}}
      />
    </Container>
    }
    </>
  );
};

export default function Instructions(props) {
  const navigate = useNavigate();
  const {control, getValues, register, reset, setValue, formState: {isDirty}} = useForm();
  const locationState = useLocation().state;
  const [state] = React.useState(locationState || {});
  const expandedItems = (data) => {
    return {
      records: !Boolean(parseInt(data && data.status)),
      informations: !Boolean(parseInt(data && parseInt(data.instructionsFg) && data.status)),
      instructions: !Boolean(parseInt(data && parseInt(data.instructionsFg) && data.status)),
      services: parseInt(data && data.status) !== 3,
      vital: parseInt(data && data.status) !== 3 && Boolean(parseInt(data && data.vitalFg)),
      cost: parseInt(data && data.status) !== 3,
      remark: parseInt(data && data.status) !== 3
    }
  };
  const [expanded, setExpanded] = React.useState(expandedItems(getValues()));
  const [open, setOpen] = React.useState({
    addService: false,
    copyModal: false,
    cancelModal: false,
    pastVital: [false, null],
    pastRemarks: false
  });
  const limitParams = {
    temperature: [32.0, 45.0],
    pulse: [40, 220],
    breath: [5, 150],
    oxygen: [70.0, 100.0],
    bloodPressure1: [60, 220],
    bloodPressure2: [20, 150]
  };
  const validationMsg = () => {
    if (Boolean(getValues("temperature")) && (parseFloat(getValues("temperature")) < limitParams.temperature[0] || limitParams.temperature[1] < parseFloat(getValues("temperature")))) {
      return "体温は " + limitParams.temperature[0] + "℃ ～ " + limitParams.temperature[1] + "℃ の間で入力してください。"
    } else if (Boolean(getValues("pulse")) && (parseFloat(getValues("pulse")) < limitParams.pulse[0] || limitParams.pulse[1] < parseFloat(getValues("pulse")))) {
      return "脈拍は " + limitParams.pulse[0] + " ～ " + limitParams.pulse[1] + " の間で入力してください。"
    } else if (Boolean(getValues("breath")) && (parseFloat(getValues("breath")) < limitParams.breath[0] || limitParams.breath[1] < parseFloat(getValues("breath")))) {
      return "呼吸は " + limitParams.breath[0] + " ～ " + limitParams.breath[1] + " の間で入力してください。"
    } else if (Boolean(getValues("oxygen")) && (parseFloat(getValues("oxygen")) < limitParams.oxygen[0] || limitParams.oxygen[1] < parseFloat(getValues("oxygen")))) {
      return "SPO2は " + limitParams.oxygen[0] + " ～ " + limitParams.oxygen[1] + " の間で入力してください。"
    } else if (Boolean(getValues("bloodPressure1")) && (parseFloat(getValues("bloodPressure1")) < limitParams.bloodPressure1[0] || limitParams.bloodPressure1[1] < parseFloat(getValues("bloodPressure1")))) {
      return "血圧(上)は " + limitParams.bloodPressure1[0] + " ～ " + limitParams.bloodPressure1[1] + " の間で入力してください。"
    } else if (Boolean(getValues("bloodPressure2")) && (parseFloat(getValues("bloodPressure2")) < limitParams.bloodPressure2[0] || limitParams.bloodPressure2[1] < parseFloat(getValues("bloodPressure2")))) {
      return "血圧(下)は " + limitParams.bloodPressure2[0] + " ～ " + limitParams.bloodPressure2[1] + " の間で入力してください。"
    } else {
      return null;
    };
  };
  const onClickCopy = (dirty) => {
    if (dirty) {
      setOpen({...open, copyModal: true});
      return;
    };
    setLastData(getValues()).then((response) => {
      setValue("st004310EditFg", false);
      reset({...getValues(), ...response.data.result});
      props.setToastState({...props.toastState, error: false, message: response.data.message});
    }).catch(error => {
      props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
    });
    setOpen({...open, copyModal: false});
  };
  const onClickSubmit = (status) => {
    if (!Boolean(parseInt(getValues("adminCheckFg")))) {
      if (!Boolean(parseInt(getValues("instructionsFg")))) {
        setInstructionsUpdate({st004200Slug: state.st004200Slug}).then((response) => {
          setValue("instructionsFg", "1");
          props.setToastState({...props.toastState, error: false, message: response.data.message});
          setExpanded(expandedItems(getValues()));
        }).catch(error => {
          props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
        });
      } else if (!Boolean(parseInt(getValues("status")))) {
        if (navigator.geolocation) {
          var timeout = () => new Promise((resolve) => {
            setTimeout(resolve, 3000, {error: "Timed out to get GPS."});
          });
          var getLocation = () => new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition(position => {
              setTimeout(resolve, 0, {latitude: position.coords.latitude, longitude: position.coords.longitude})
            },
            positionError => {
              setTimeout(resolve, 0, {error: positionError.message});
            });
          });
          Promise.race([timeout(), getLocation()]).then((value) => {
            setVisitStart({st004211Slug: getValues("st004211Slug"), latitude: value.latitude, longitude: value.longitude, error: value.error}).then((response) => {
              setValue("status", "1");
              setValue("visitStartTime", new Date().getHours().toString().padStart(2, '0') + ":" + new Date().getMinutes().toString().padStart(2, '0'));
              props.setToastState({...props.toastState, error: false, message: response.data.message});
              setExpanded(expandedItems(getValues()));
              reset({...getValues()});
            }).catch(error => {
              props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
            });
          });
        } else {
          setVisitStart({st004211Slug: getValues("st004211Slug"), error: "'Geolocation' is not supported by that browser."}).then((response) => {
            setValue("status", "1");
            setValue("visitStartTime", new Date().getHours().toString().padStart(2, '0') + ":" + new Date().getMinutes().toString().padStart(2, '0'));
            props.setToastState({...props.toastState, error: false, message: response.data.message});
            setExpanded(expandedItems(getValues()));
            reset({...getValues()});
          }).catch(error => {
            props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
          });
        };
      } else {
        if (!Boolean(validationMsg())) {
          setVisitUpdate({...getValues(), status: status}).then((response) => {
            props.setToastState({...props.toastState, error: false, message: response.data.message});
            navigate("/day_schedule");
          }).catch(error => {
            props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
          });
        } else {
          props.setToastState({...props.toastState, error: true, message: validationMsg()});
        }
      };
    };
  };
  const onClickCancel = () => {
    setVisitCancellation({st004211Slug: getValues("st004211Slug")}).then((response) => {
      if (parseInt(getValues("status")) === 3) {
        setValue("status", "0");
        props.setToastState({...props.toastState, error: false, message: response.data.message});
        setExpanded(expandedItems(getValues()));
      } else {
        props.setToastState({...props.toastState, error: false, message: response.data.message});
        navigate("/day_schedule");
      };
    }).catch(error => {
      props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
    });
    setOpen({...open, cancelModal: !(open.cancelModal)});
  };
  const submitBtnText = () => {
    if (Boolean(parseInt(getValues("adminCheckFg")))) {
      return ["btn-submit", "管理者確認済"];
    } else if (!Boolean(parseInt(getValues("instructionsFg")))) {
      return ["btn-select", "指示確認"];
    } else {
      const textList = ["訪問開始", "実績登録", "実績修正"]
      return ["btn-submit", textList[parseInt(getValues("status")) || 0]];
    };
  };
  const setRealTime = () => {
    if (getValues("timefY") !== getValues("timef") || getValues("timetY") !== getValues("timet")) {
      setValue("timef", getValues("timefY"));
      setValue("timet", getValues("timetY"));
    } else {
      setValue("timef", getValues("visitStartTime"));
      setValue("timet", new Date().getHours().toString().padStart(2, "0") + ":" + new Date().getMinutes().toString().padStart(2, "0"));
    };
  };

  React.useEffect(() => {
    window.addEventListener("beforeunload", (e) => {
      sessionStorage.setItem("instructions", JSON.stringify(getValues()));
    });
    if (Boolean(sessionStorage.getItem("instructions"))) {
      Object.keys(JSON.parse(sessionStorage.getItem("instructions"))).map((data) => (
        setValue(data, JSON.parse(sessionStorage.getItem("instructions"))[data])
      ));
      setExpanded(expandedItems(JSON.parse(sessionStorage.getItem("instructions"))));
    } else {
      getInstructions({st004200Slug: state.st004200Slug}).then(response => {
        Object.keys(response.data).map((data) => (
          setValue(data, response.data[data])
        ));
        setValue("consciousnessLevel", Boolean(response.data.consciousnessLevel) ? response.data.consciousnessLevel : "")
        setValue("transportation", Boolean(parseInt(response.data.transportation)) ? response.data.transportation : "")
        setValue("carfate", Boolean(parseInt(response.data.carfate)) ? response.data.carfate : "")
        setValue("amountAdj", Boolean(parseInt(response.data.amountAdj)) ? response.data.amountAdj : "")
        setValue("amountEtc", Boolean(parseInt(response.data.amountEtc)) ? response.data.amountEtc : "")
        setValue("sendMailFg", false);
        setValue("st004310EditFg", false);
        setExpanded(expandedItems(response.data));
        reset({...getValues()});
      }).catch(error => {
        props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
        navigate("/day_schedule");
      });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (Object.keys(getValues()).length !== 0 &&
    <Container
      maxWidth = "sm"
      sx = {{p: 2, flexGrow: 1}}
    >
      <Box
        position = "relative"
        sx = {{textAlign: "center"}}
      >
        <List
          sx = {{p: 0}}
        >
          <ListItem
            sx = {{display: "flex", position: "relative", justifyContent: "center", p: 0}}
          >
            <IconButton
              onClick = {() => navigate("/day_schedule")}
              sx = {{position: "absolute", left: 0, p: 2}}
            >
              <UTurnLeftIcon
                sx = {{transform: "rotate(90deg)"}}
              />
            </IconButton>
            <TextField
              className = "bgcolor-white"
              disabled
              sx = {{width: "60%"}}
              type = "date"
              value = {state.date}
            />
            {Boolean(parseInt(getValues("instructionsFg"))) && getValues("status") === "1" &&
            <IconButton
              onClick = {() => onClickSubmit("1")}
              sx = {{position: "absolute", right: 0, p: 2}}
            >
              <SaveIcon/>
            </IconButton>}
          </ListItem>
        </List>
        <List>
          <Accordion
            className = "btn-select"
            expanded = {expanded.informations}
            onClick = {() => setExpanded({...expanded, informations: !(expanded.informations)})}
            sx = {{m: "0px 16px!important", p: 2, textAlign: "left", boxShadow: "none", borderRadius: "0!important"}}
          >
            <AccordionSummary
              expandIcon = {<ExpandMoreIcon fontSize = "small" sx = {{color: "rgba(0, 0, 0, 0.54)"}} />}
              sx = {{p: 0, height: 36, minHeight: "0!important"}}
            >
              <ListItemText
                primary = {getValues("nm") || "--"}
              />
            </AccordionSummary>
            <AccordionDetails
              sx = {{p: 0}}
            >
              <ListItemText
                secondary = {
                  <React.Fragment>
                    <Typography>
                      サービス
                    </Typography>
                    {!Boolean(getValues("timelessOtherFg")) &&
                    <Typography
                      sx = {{ml: 1}}
                    >
                      {(getValues("hourfDt") || "--:--") + "～" + (getValues("hourtDt") || "--:--")}
                    </Typography>}
                    <Typography
                      sx = {{ml: 1}}
                    >
                      {getValues("svRnm") || "--"}
                    </Typography>
                    {/* {Boolean(getValues("tel")) &&
                    <>
                    <br></br>
                    <Typography>
                    電話番号
                    </Typography>
                    <Typography
                      sx = {{ml: 1}}
                    >
                      {getValues("tel")}
                    </Typography>
                    </>}
                    {Boolean(getValues("address")) &&
                    <>
                    <br></br>
                    <Typography>
                      住所
                    </Typography>
                    <Typography
                      sx = {{ml: 1}}
                    >
                      {getValues("address") + getValues("address2")}
                    </Typography>
                    </>} */}
                  </React.Fragment>
                }
                secondaryTypographyProps = {{component: "div"}}
              />
            </AccordionDetails>
          </Accordion>
          {(!Boolean(parseInt(getValues("instructionsFg"))) || !Boolean(parseInt(getValues("status")))) && !(getValues("otherBusinessFg")) &&
          <ListItem
            sx = {{m: "10px 0px 5px", p: 0}}
          >
            <Button
              className = "btn-submit"
              onClick = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), 1]})}
              sx = {{mr: "auto", width: "48%", height: 36, minHeight: "0!important", borderRadius: 12}}
            >
              <HistoryIcon
                fontSize = "small"
                sx = {{pr: 0.5}}
              />
              <Typography
                sx = {{pr: 0.5}}
              >
                バイタル
              </Typography>
            </Button>
            <Button
              className = "btn-submit"
              onClick = {() => setOpen({...open, pastRemarks: !(open.pastRemarks)})}
              sx = {{ml: "auto", width: "48%", height: 36, minHeight: "0!important", borderRadius: 12}}
            >
              <HistoryIcon
                fontSize = "small"
                sx = {{pr: 0.5}}
              />
              <Typography
                sx= {{pr: 0.5}}
              >
                特記事項
              </Typography>
            </Button>
          </ListItem>}
          {Boolean(parseInt(getValues("instructionsFg"))) && getValues("status") === "1" &&
          <Button
            className = "btn-submit"
            // disabled = {Boolean()}
            onClick = {() => onClickCopy(isDirty)}
            sx = {{mt: 2, width: "100%"}}
          >
            <Typography
              className = "btn-txt-lg"
            >
              前回実績を反映
            </Typography>
          </Button>}
          {Boolean(getValues("instructions")) && !(getValues("otherBusinessFg")) &&
          <Accordion
            expanded = {expanded.instructions}
            sx = {{mt: 2, boxShadow: "none"}}
          >
            <AccordionSummary
              className = "btn-submit"
              onClick = {() => setExpanded({...expanded, instructions: !(expanded.instructions)})}
              sx = {{height: 36, minHeight: "0!important", borderRadius: 12}}
            >
              <Typography
                sx = {{m: "auto"}}
              >
                指示内容
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx = {{pt: 1}}
            >
              <Container
                maxWidth = "sm"
                sx = {{flexGrow: 1}}
              >
                <TextField
                  disabled
                  fullWidth
                  maxRows = {8}
                  multiline
                  placeholder = "指示内容"
                  size = "small"
                  {...register("instructions")}
                />
              </Container>
            </AccordionDetails>
          </Accordion>}
          {!(getValues("otherBusinessFg")) &&
          <Accordion
            expanded = {expanded.services}
            sx = {{mt: 2, boxShadow: "none"}}
          >
            <AccordionSummary
              className = "btn-submit"
              onClick = {() => setExpanded({...expanded, services: !(expanded.services)})}
              sx = {{height: 36, minHeight: "0!important", borderRadius: 12}}
            >
              <Typography
                sx = {{margin: "auto"}}
              >
              {Boolean(parseInt(getValues("instructionsFg"))) && Boolean(parseInt(getValues("status"))) ? "実施項目" : "指示項目"}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx = {{p: 0, pt: 1}}
            >
              <Container
                maxWidth = "sm"
                sx = {{flexGrow: 1}}
              >
                <Container
                  sx = {{padding: "0px!important"}}
                >
                  {getValues("st004300List").map((st004300) => (
                    <InstructionForm
                      control = {control}
                      getValues = {getValues}
                      key = {"st004300" + st004300}
                      onClick = {(e, val) => setValue("st004310List", e.target.checked ? [...getValues("st004310List"), val] : (getValues("st004310List")).filter(s => s[0] !== val[0]), {shouldDirty: true})}
                      onChange = {(val) => setValue("charInputList", [...getValues("charInputList").filter(char => char[0] !== st004300[0]), [st004300[0], val]], {shouldDirty: true})}
                      st = {st004300}
                    />
                  ))}
                </Container>
                <Container
                  sx = {{padding: "0px!important", borderTop: "1px dashed rgba(0, 0, 0, 0.38)"}}
                >
                  {getValues("st004310ViewList").map((st004310v) => (
                    !Boolean(getValues("st004300List").find(st004300 => st004300[0] === st004310v[0])) &&
                    <InstructionForm
                      control = {control}
                      getValues = {getValues}
                      key = {"st004310" + st004310v}
                      onClick = {(e, val) => setValue("st004310List", e.target.checked ? [...getValues("st004310List"), val] : (getValues("st004310List")).filter(s => s[0] !== val[0]), {shouldDirty: true})}
                      onChange = {(val) => setValue("charInputList", [...getValues("charInputList").filter(char => char[0] !== st004310v[0]), [st004310v[0], val]], {shouldDirty: true})}
                      st = {st004310v}
                    />
                  ))}
                </Container>
                <Container
                  sx = {{mt: 3, padding: "0px!important", display: "flex"}}
                >
                  <FormControlLabel
                    control = {
                      <IconButton
                        id = "add_service_btn"
                        onClick = {() => {
                          setValue("st004310EditFg", true, {shouldDirty: true});
                          setOpen({...open, addService: !(open.addService)});
                        }}
                        sx = {{padding: "9px"}}
                      >
                        <AddCircleOutlineIcon
                          color = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2 ? "disabled" : "primary"}
                        />
                      </IconButton>
                    }
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                    label = "項目編集"
                    sx = {!Boolean(parseInt(getValues("status"))) || !Boolean(parseInt(getValues("instructionsFg"))) ? {display: "none"} : {m: 0, pl: 1}}
                  />
                </Container>
              </Container>
            </AccordionDetails>
          </Accordion>}
          {Boolean(parseInt(getValues("instructionsFg"))) && Boolean(parseInt(getValues("status"))) && parseInt(getValues("status")) < 3 &&
          <>
          {!(getValues("otherBusinessFg")) &&
          <Accordion
            expanded = {expanded.vital}
            sx = {{mt: 2, boxShadow: "none"}}
          >
            <AccordionSummary
              className = "btn-submit"
              onClick = {() => setExpanded({...expanded, vital: !(expanded.vital)})}
              sx = {{height: 36, minHeight: "0!important", borderRadius: 12}}
            >
              <Typography
                sx = {{margin: "auto"}}
              >
                バイタル
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx = {{pt: 1}}
            >
              <Container
                maxWidth = "sm"
                sx = {{flexGrow: 1}}
              >
                <Box
                  sx = {{display: "flex"}}
                >
                  <IconButton
                    onClick = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), 1]})}
                    sx = {{p: 0, pb: 1, mr: 2}}
                  >
                    <HistoryIcon
                      color = "primary"
                    />
                  </IconButton>
                  <TextField
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                    fullWidth
                    inputProps = {{maxLength: 4, style: {textAlign: "right"}}}
                    InputProps = {{
                      startAdornment:
                        <InputAdornment
                          position = "start"
                        >
                          体温
                        </InputAdornment>,
                      endAdornment:
                        <InputAdornment
                          position = "end"
                        >
                          ℃
                        </InputAdornment>
                    }}
                    size = "small"
                    sx = {{mb: 1}}
                    type = "number"
                    variant = "standard"
                    {...register("temperature")}
                  />
                </Box>
                <Box
                  sx = {{display: "flex"}}
                >
                  <IconButton
                    onClick = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), 2]})}
                    sx = {{p: 0, pb: 1, mr: 2}}
                  >
                    <HistoryIcon
                      color = "primary"
                    />
                  </IconButton>
                  <TextField
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                    fullWidth
                    inputProps = {{maxLength: 3, style: {textAlign: "right"}}}
                    InputProps = {{
                      startAdornment:
                        <InputAdornment
                          position = "start"
                        >
                          脈拍
                        </InputAdornment>
                    }}
                    size = "small"
                    sx = {{mb: 1}}
                    type = "number"
                    variant = "standard"
                    {...register("pulse")}
                  />
                </Box>
                <Box
                  sx = {{display: "flex"}}
                >
                  <IconButton
                    onClick = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), 3]})}
                    sx = {{p: 0, pb: 1, mr: 2}}
                  >
                    <HistoryIcon
                      color = "primary"
                    />
                  </IconButton>
                  <TextField
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                    fullWidth
                    inputProps = {{maxLength: 3, style: {textAlign: "right"}}}
                    InputProps = {{
                      startAdornment:
                        <InputAdornment
                          position = "start"
                        >
                          呼吸
                        </InputAdornment>
                    }}
                    size = "small"
                    sx = {{mb: 1}}
                    type = "number"
                    variant = "standard"
                    {...register("breath")}
                  />
                </Box>
                <Box
                  sx = {{display: "flex"}}
                >
                  <IconButton
                    onClick = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), 4]})}
                    sx = {{p: 0, pb: 1, mr: 2}}
                  >
                    <HistoryIcon
                      color = "primary"
                    />
                  </IconButton>
                  <TextField
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                    fullWidth
                    inputProps = {{maxLength: 4, style: {textAlign: "right"}}}
                    InputProps = {{
                      startAdornment:
                        <InputAdornment
                          position = "start"
                        >
                          SPO2
                        </InputAdornment>
                    }}
                    size = "small"
                    sx = {{mb: 1}}
                    type = "number"
                    variant = "standard"
                    {...register("oxygen")}
                  />
                </Box>
                <Box
                  sx = {{display: "flex"}}
                >
                  <IconButton
                    onClick = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), 5]})}
                    sx = {{p: 0, pb: 1, mr: 2}}
                  >
                    <HistoryIcon
                      color = "primary"
                    />
                  </IconButton>
                  <TextField
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                    fullWidth
                    inputProps = {{maxLength: 3, style: {textAlign: "right"}}}
                    InputProps = {{
                      startAdornment:
                        <InputAdornment
                          position = "start"
                        >
                          血圧(上)
                        </InputAdornment>
                    }}
                    size = "small"
                    sx = {{mb: 1}}
                    type = "number"
                    variant = "standard"
                    {...register("bloodPressure1")}
                  />
                </Box>
                <Box
                  sx = {{display: "flex"}}
                >
                  <IconButton
                    onClick = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), 5]})}
                    sx = {{p: 0, pb: 1, mr: 2}}
                  >
                    <HistoryIcon
                      color = "primary"
                    />
                  </IconButton>
                  <TextField
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                    fullWidth
                    inputProps = {{maxLength: 3, style: {textAlign: "right"}}}
                    InputProps = {{
                      startAdornment:
                        <InputAdornment
                          position = "start"
                        >
                          血圧(下)
                        </InputAdornment>
                    }}
                    size = "small"
                    sx = {{mb: 1}}
                    type = "number"
                    variant = "standard"
                    {...register("bloodPressure2")}
                  />
                </Box>
                <Controller
                  control = {control}
                  name = "consciousnessLevel"
                  render = {({field}) => (
                    <TextField
                      disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                      fullWidth
                      label = "意識レベル"
                      SelectProps = {{MenuProps: {style: {maxHeight: 200}}}}
                      select
                      size = "small"
                      sx = {{mt: 1, mb: 1, textAlign: "left"}}
                      {...field}
                    >
                      <MenuItem
                        value = ""
                      >
                        　
                      </MenuItem>
                      {getValues("consciousnessLevelList").map((consciousnessLevel) => (
                        <MenuItem
                          key = {"consciousnessLevel" + consciousnessLevel[0]}
                          sx = {{whiteSpace: "normal"}}
                          value = {consciousnessLevel[0]}
                        >
                          {consciousnessLevel[1]}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </Container>
            </AccordionDetails>
          </Accordion>}
          <Accordion
            expanded = {expanded.cost}
            sx = {{mt: 2, boxShadow: "none"}}
          >
            <AccordionSummary
              className = "btn-submit"
              onClick = {() => setExpanded({...expanded, cost: !(expanded.cost)})}
              sx = {{height: 36, minHeight: "0!important", borderRadius: 12}}
            >
              <Typography
                sx = {{margin: "auto"}}
              >
                交通費等
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx = {{pt: 1}}
            >
              <Container
                maxWidth = "sm"
                sx = {{flexGrow: 1}}
              >
                <Controller
                  control = {control}
                  name = "transportation"
                  render = {({field}) => (
                    <TextField
                      disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                      fullWidth
                      label = "移動手段"
                      SelectProps = {{MenuProps: {style: {maxHeight: 200}}}}
                      select
                      size = "small"
                      sx = {{mt: 1, mb: 1, textAlign: "left"}}
                      {...field}
                    >
                      <MenuItem
                        value = ""
                      >
                        　
                      </MenuItem>
                      {getValues("transportationList").map((transportation) => (
                        <MenuItem
                          key = {"transportation" + transportation[0]}
                          value = {transportation[0]}
                        >
                          {transportation[1]}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
                <TextField
                  disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                  fullWidth
                  inputProps = {{style: {textAlign: "right"}}}
                  InputProps = {{startAdornment: <InputAdornment position="start">交通費</InputAdornment>, endAdornment: <InputAdornment position="end">円</InputAdornment>}}
                  size = "small"
                  sx = {{mb: 1}}
                  type = "number"
                  variant = "standard"
                  {...register("carfate")}
                />
                <TextField
                  disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                  fullWidth
                  inputProps = {{style: {textAlign: "right"}}}
                  InputProps = {{startAdornment: <InputAdornment position="start">調整金額</InputAdornment>, endAdornment: <InputAdornment position="end">円</InputAdornment>}}
                  size = "small"
                  sx = {{mb: 1}}
                  type = "number"
                  variant = "standard"
                  {...register("amountAdj")}
                />
                <TextField
                  disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                  fullWidth
                  inputProps = {{style: {textAlign: "right"}}}
                  InputProps = {{startAdornment: <InputAdornment position="start">その他金額</InputAdornment>, endAdornment: <InputAdornment position="end">円</InputAdornment>}}
                  size = "small"
                  type = "number"
                  variant = "standard"
                  {...register("amountEtc")}
                />
              </Container>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded = {expanded.remark}
            sx = {{mt: 2, boxShadow: "none"}}
          >
            <AccordionSummary
              className = "btn-submit"
              onClick = {() => setExpanded({...expanded, remark: !(expanded.remark)})}
              sx = {{height: 36, minHeight: "0!important", borderRadius: 12}}
            >
              <Typography
                sx = {{margin: "auto"}}
              >
                特記事項
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx = {{pt: 1, textAlign: "left"}}
            >
              <Container
                maxWidth = "sm"
                sx = {{flexGrow: 1}}
              >
                <TextField
                  disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                  fullWidth
                  inputProps = {{maxLength: 500}}
                  maxRows = {8}
                  minRows = {5}
                  multiline
                  placeholder = "特記事項"
                  size = "small"
                  sx = {{mt: 1}}
                  {...register("remarks")}
                />
              </Container>
              <Container
                maxWidth = "sm"
                sx = {{display: "flex", justifyContent: "flex-end"}}
              >
                <IconButton
                  onClick = {() => setOpen({...open, pastRemarks: !(open.pastRemarks)})}
                  sx = {{p: 0, mr: "auto"}}
                >
                  <HistoryIcon
                    color = "primary"
                  />
                </IconButton>
                <Controller
                  control = {control}
                  name = "alertFg"
                  render = {({field, fieldState}) => (
                    <FormControlLabel
                      control = {
                        <Switch
                          checked = {getValues("alertFg")}
                          color = "error"
                          disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || parseInt(getValues("status")) > 2}
                          onChange = {(e) => field.onChange(e.target.checked)}
                          {...field}
                        />
                      }
                      label = "重要"
                      sx = {{m: 0, pr: 1}}
                    />
                  )}
                />
              </Container>
              {["1", "2"].includes(getValues("status")) && Boolean(getValues("adminMailaddress")) &&
              <Container
                maxWidth = "sm"
                sx = {{p: 1, display: "flex"}}
              >
                <FormControlLabel
                  control = {
                    <Controller
                      control = {control}
                      name = "sendMailFg"
                      render = {({field}) => (
                        <FormControlLabel
                          control = {
                            <Checkbox
                              checked = {getValues("sendMailFg")}
                              checkedIcon = {
                                <TaskAltIcon
                                color = {Boolean(parseInt(getValues("adminCheckFg"))) ? "disabled" : "success"}
                                />
                              }
                              color = "default"
                              icon = {<RadioButtonUncheckedIcon />}
                              onChange = {(e) => field.onChange(e.target.checked)}
                              {...field}
                            />
                          }
                        />
                      )}
                    />
                  }
                  disabled = {Boolean(parseInt(getValues("adminCheckFg")))}
                  label = {"責任者へ完了通知"}
                  sx = {{m: 0}}
                />
              </Container>}
            </AccordionDetails>
          </Accordion>
          <Drawer
            anchor = "bottom"
            open = {open.addService}
            PaperProps = {{sx: {maxHeight: "80%"}}}
          >
            <AddService
              setValue = {setValue}
              state = {getValues()}
            />
          </Drawer>
          </>}
          <Drawer
            anchor = "bottom"
            onClose = {() => setOpen({...open, pastVital: [!(open.pastVital[0]), open.pastVital[1]]})}
            open = {open.pastVital[0]}
            PaperProps = {{sx: {maxHeight: "80%"}}}
          >
            <PastVital
              data = {getValues("pastDataList")}
              tab = {open.pastVital[1]}
              value = {[state.date, getValues("temperature"), getValues("pulse"), getValues("breath"), getValues("oxygen"), [getValues("bloodPressure1"), getValues("bloodPressure2")]]}
            />
          </Drawer>
          <Drawer
            anchor = "bottom"
            onClose = {() => setOpen({...open, pastRemarks: !(open.pastRemarks)})}
            open = {open.pastRemarks}
            PaperProps = {{sx: {maxHeight: "80%"}}}
          >
            <PastRemarks
              custom = {getValues("custom")}
              data = {getValues("pastDataList")}
            />
          </Drawer>
          {parseInt(getValues("status")) < 3 && !Boolean(getValues("timelessOtherFg")) &&
          <>
          <Container
            maxWidth = "sm"
            sx = {{display: "flex", flexGrow: 1, mt: 2}}
          >
            <TextField
              disabled
              fullWidth
              inputProps = {{style: {textAlign: "center"}}}
              InputProps = {{startAdornment: <InputAdornment position="start">予定</InputAdornment>}}
              size = "small"
              sx = {{mb: 1}}
              type = "time"
              variant = "standard"
              {...register("timefY")}
            />
            <TextField
              disabled
              fullWidth
              inputProps = {{style: {textAlign: "center"}}}
              InputProps = {{
                startAdornment:
                  <InputAdornment position = "start">
                    ～
                  </InputAdornment>,
                endAdornment:
                  <IconButton
                    disabled
                    sx = {{p: 0, mb: 1, opacity: 0}}
                  >
                    <ScheduleIcon
                      fontSize = "small"
                    />
                  </IconButton>
              }}
              size = "small"
              sx = {{mb: 1, width: "90%"}}
              type = "time"
              variant = "standard"
              {...register("timetY")}
            />
          </Container>
          <Container
            maxWidth = "sm"
            sx = {{display: "flex", flexGrow: 1}}
          >
            <TextField
              disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || !Boolean(parseInt(getValues("status"))) || parseInt(getValues("status")) > 2 || !Boolean(parseInt(getValues("instructionsFg")))}
              fullWidth
              inputProps = {{style: {textAlign: "center"}}}
              InputProps = {{
                startAdornment:
                  <InputAdornment position="start">
                    実績
                  </InputAdornment>
              }}
              size = "small"
              sx = {{mb: 1}}
              type = "time"
              variant = "standard"
              {...register("timef")}
            />
            <TextField
              disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || !Boolean(parseInt(getValues("status"))) || parseInt(getValues("status")) > 2 || !Boolean(parseInt(getValues("instructionsFg")))}
              fullWidth
              inputProps = {{style: {textAlign: "center"}}}
              InputProps = {{
                startAdornment:
                  <InputAdornment position = "start">
                    ～
                  </InputAdornment>,
                endAdornment:
                  <IconButton
                    disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || !Boolean(parseInt(getValues("status"))) || parseInt(getValues("status")) > 2 || !Boolean(parseInt(getValues("instructionsFg")))}
                    onClick = {() => setRealTime()}
                    sx = {{p: 0, mb: 1}}
                  >
                    <ScheduleIcon
                      fontSize = "small"
                    />
                  </IconButton>
              }}
              size = "small"
              sx = {{mb: 1, width: "90%"}}
              type = "time"
              variant = "standard"
              {...register("timet")}
            />
          </Container>
          </>}
          <Modal
            open = {open.copyModal}
            closeAfterTransition
          >
            <Box
              className = "basic-modal"
            >
              <Typography>
                現在の入力内容は破棄されます。
              </Typography>
              <Typography>
                前回の実績内容を反映しますか？
              </Typography>
              <Box
                sx = {{textAlign: "right"}}
              >
                <Button
                  onClick = {() => onClickCopy(false)}
                  sx = {{}}
                >
                  はい
                </Button>
                <Button
                  onClick = {() => setOpen({...open, copyModal: !(open.copyModal)})}
                  sx = {{}}
                >
                  いいえ
                </Button>
              </Box>
            </Box>
          </Modal>
          <Modal
            open = {open.cancelModal}
            closeAfterTransition
          >
            <Box
              className = "basic-modal"
            >
              <Typography>
                {parseInt(getValues("status")) > 2 ? "キャンセル状態を解除しますか？" : "訪問予定をキャンセルしますか？"}
              </Typography>
              <Box
                sx = {{textAlign: "right"}}
              >
                <Button
                  onClick = {() => onClickCancel()}
                  sx = {{}}
                >
                  はい
                </Button>
                <Button
                  onClick = {() => setOpen({...open, cancelModal: !(open.cancelModal)})}
                  sx = {{}}
                >
                  いいえ
                </Button>
              </Box>
            </Box>
          </Modal>
          <ListItem
            sx = {{m: "10px 0px 5px", p: 0}}
          >
            {parseInt(getValues("status")) < 3 &&
            <Button
              className = {submitBtnText()[0]}
              disabled = {Boolean(parseInt(getValues("adminCheckFg"))) || moment().format("yyyy-MM-DD") < state.date}
              onClick = {() => onClickSubmit("2")}
              sx = {{mr: "auto", width: "48%"}}
            >
              <Typography
                className = "btn-txt-lg"
              >
                {submitBtnText()[1]}
              </Typography>
            </Button>}
            {(!(Boolean(parseInt(getValues("status")))) || parseInt(getValues("status")) > 2) &&
            <Button
              className = "btn-caution"
              disabled = {Boolean(parseInt(getValues("adminCheckFg")))}
              onClick = {() => setOpen({...open, cancelModal: !(open.cancelModal)})}
              sx = {{ml: "auto", pl: 0.5, pr: 0.5, width: "48%"}}
            >
              <Typography
                className = "btn-txt-lg"
              >
                {Boolean(parseInt(getValues("status"))) ? "キャンセル済" : "訪問キャンセル"}
              </Typography>
            </Button>}
          </ListItem>
        </List>
      </Box>
    </Container>
  );
};
